import ServerProxy from '../../proxy/ServerProxy';
import { left_nav_bar_def } from "@/data/left-nav-bar"
const REPStore = {
    state: {
        // eslint-disable-next-line no-undef
        config:config,
        showProgressBar: false,
        leftBarItems:[],
        footerItems:[],
        flowItems:[],
        centralItems:[],
        userInfo: null,
        isCommunicationAdmin:false,
        isNewsAdmin:false,
        isSystemAdmin:false,
        isShowcaseAdmin:false,
        userSiloList: [],
        siloDetails: [],
        snackbarDetails: {
            show: false,
            timeout: 60000,
            msg: "",
        },
        commuicationFields:[],
        managementFilterFields:[],
        userGroups:[],
        landingPageComms:[],
        savedFilters:null,
        processingOverlay:false,
        confirmDialogDetails:{
            show:false
        },
        news:[],
        serverProxy: new ServerProxy(),
    },
    getters: {
        getProgressBar(state) {
            return state.showProgressBar;
        },
        getLeftBarItems(state) {
            return state.leftBarItems;
        },
        getFooterItems(state) {
            return state.footerItems;
        },
        getFlowItems(state) {
            return state.flowItems;
        },
        getCentralItems(state) {
            return state.centralItems;
        },
        getUserInfo(state) {
            return state.userInfo;
        },

        getIsCommunicationAdmin(state) {
            return state.isCommunicationAdmin;
        },

        getIsNewsAdmin(state) {
            return state.isNewsAdmin;
        },

        getIsSystemAdmin(state) {
            return state.isSystemAdmin;
        },

        getIsShowcaseAdmin(state) {
            return state.isShowcaseAdmin;
        },

        getUserSiloList(state){
            return state.userSiloList;
        },

        getSiloDetails(state){
            return state.siloDetails;
        },

        getSnackbarDetails(state) {
            return state.snackbarDetails;
        },

        getCommuicationFields(state){
            return state.commuicationFields;
        },

        getUsergroups(state){
            return state.userGroups;
        },


        getManagementFilterFields(state){
            return state.managementFilterFields;
        },

        getLandingPageComms(state){
            return state.landingPageComms;
        },

        getSavedFilters(state){
            return state.savedFilters;
        },

        getProcessingOverlay(state){
            return state.processingOverlay;
        },


        getConfirmDialogDetails(state){
            return state.confirmDialogDetails;
        },

        getNews(state){
            return state.news;
        }

    },
    actions: {
        setProgressBar({ commit }, status) {
            commit('setProgressBar', status);
        },

        setUserSiloList({ commit,state } , userId){
            return new Promise((resolve, reject) => {
            state.serverProxy.serverRequest({
                url: `${state.config.rep_service_url}/dataglance/silos/${userId}`,
                method: `GET`,
                headers: { 'Content-Type': `application/json` },
            })
            .then(response => {
                resolve(response);
                commit('setUserSiloList', response);
            })
            .catch(err =>             
                reject(err)
            );
            });
        },

        setSiloDetails({ commit,state } , value){
            return new Promise((resolve, reject) => {
            state.serverProxy.serverRequest({
                url: `${state.config.rep_service_url}/dataglance/detail/${value}`,
                method: `GET`,
                headers: { 'Content-Type': `application/json` },
            })
            .then(response => {
                resolve(response);
                commit('setSiloDetails', response);
            })
            .catch(err =>
                reject(err)
            );
            });
        },

        setLeftBarItems({ commit,state } , userId) {
            return new Promise((resolve, reject) => {
            state.serverProxy.serverRequest({
                url: `${state.config.rep_service_url}/user/${userId}`,
                method: `GET`,
                needMask:true,
                headers: { 'Content-Type': `application/json` },

            })
                .then(response => {
                    commit('setUserInfo',response)
                    const navigationData = response.accessNavigationData;
                    const applications = navigationData.filter( ele => ele.type === "Application");
                    const footerItems = navigationData.filter( ele => ele.type === "Footer");
                    const flowItems = navigationData.filter( ele => ele.type === "Flowbutton");
                    const centralItems = navigationData.filter( ele => ele.type === "Central");
                    commit('setFooterItems',footerItems);
                    commit('setFlowItems',flowItems);
                    commit('setCentralItems',centralItems);
                    //add menu for application access panel
                    const leftItems = left_nav_bar_def.map(item => {
                        const newItem = item;
                        const foundItems = applications.filter(app => app.name === item.name);
                        //No links found for current App
                        if(foundItems.length == 0){
                            return item;
                        }else if(foundItems.length == 1){
                            newItem.url = foundItems[0].url;
                            newItem.title = foundItems[0].displayName;
                            newItem.tooltip = foundItems[0].tooltip;
                            newItem.disabled = false;
                            return newItem;
                        }else{
                            newItem.title = foundItems[0].displayName;
                            newItem.disabled = false;
                            const submenu = [];
                            foundItems.forEach(ele =>{
                                const menu = {};
                                menu.title = ele.domain;
                                menu.tooltip = ele.tooltip;
                                menu.url = ele.url;
                                submenu.push(menu);
                            });
                            newItem.submenu = submenu;
                            return newItem;
                        }

                    });
                    commit('setLeftBarItems', leftItems);

                    //set REP Permissions
                    commit('setIsCommunicationAdmin',response.commAdmin);
                    commit('setIsNewsAdmin',response.newsAdmin);
                    commit('setIsSystemAdmin',response.systemAdmin);
                    commit('setIsShowcaseAdmin',response.showcaseAdmin);
                    resolve(response);

                })
                .catch(err =>
                    reject(err)
                );
            });
        },
        setSnackbarDetails({ commit }, details) {
            commit("setSnackbarDetails", details);
        },
        closeSnackbar({ commit }) {
            commit("closeSnackbar");
        },
        fetchCommunicationField({ commit,state }){
            state.serverProxy.serverRequest({
                url: `${state.config.rep_service_url}/communications/fields`,
                method: `GET`,
                headers: { 'Content-Type': `application/json` },

            })
                .then(response => {
                    commit('setCommuicationFields',response)
                }).catch(err =>
                    console.log(err)
                );
        },
        initUserGroups({commit}){
            commit("setUsergroups",[]);
        },
        loadUserGroups({commit,state}, type){
            let url = '/communications/usergroups/' + type;
            if(type == "All"){
                url = "/communications/allusergroups";
            }
            return new Promise((resolve, reject) => {
            state.serverProxy.serverRequest({
                url: `${state.config.rep_service_url}${url}`,
                method: `GET`,
                needMask: true,
                headers: { 'Content-Type': `application/json` },

            })
                .then(response => {
                    if(response && !response.error){
                        commit('setUsergroups',response);
                    }else{
                        commit('setUsergroups',[]);
                    }
                    resolve(response);
                }).catch(err =>
                    // console.log(err),
                    reject(err)
                );
            });
        },
        loadUserGroupsData({state}){
            return new Promise((resolve, reject) => {
            state.serverProxy.serverRequest({
                url: `${state.config.rep_service_url}/communications/usergroups`,
                method: `GET`,
                needMask: true,
                headers: { 'Content-Type': `application/json` },

            })
                .then(response => {                    
                    resolve(response);
                }).catch(err =>
                    // console.log(err),
                    reject(err)
                );
            });
        },
        getUsergroupsForServer({state}, serverName){
            return new Promise((resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/server/${serverName}`,
                    method: `GET`,
                    needMask:true,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        getUsergroupsForRetailers({state},retailName){
            return new Promise( (resolve, reject) => {
                    state.serverProxy.serverRequest({
                        url: `${state.config.rep_service_url}/communications/team/${retailName}`,
                        method: `GET`,
                        needMask:true,
                        headers: { 'Content-Type': `application/json` },
                    })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(err =>             
                        reject(err)
                    );
                });
        },
        getRetailersGroups({state}){
            return new Promise( (resolve, reject) => {
                    state.serverProxy.serverRequest({
                        url: `${state.config.rep_service_url}/communications/retailers/groups`,
                        method: `GET`,
                        headers: { 'Content-Type': `application/json` },
                    })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(err =>             
                        reject(err)
                    );
                });
        },
        getServersGroups({state}){
            return new Promise( (resolve, reject) => {
                    state.serverProxy.serverRequest({
                        url: `${state.config.rep_service_url}/communications/servers/groups`,
                        method: `GET`,
                        headers: { 'Content-Type': `application/json` },
                    })
                    .then(response => {
                        resolve(response);
                    })
                    .catch(err =>             
                        reject(err)
                    );
                });
        },
        saveCommunication({state},payload){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/communication/${payload.userId}`,
                    body:payload.entity,
                    method: `POST`,
                    needMask:true,
                    callbackFunc:payload.callbackFunc,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        saveCommunicationUpdate({state},payload){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/update?userId=${payload.userId}`,
                    body:payload.entity,
                    method: `POST`,
                    needMask:true,
                    callbackFunc:payload.callbackFunc,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        searchCommunications({state},params){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/search?userId=${params.userId}`,
                    method: `POST`,
                    body:params.requestdata,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        fetchManagementFilterFields({commit, state}){
            state.serverProxy.serverRequest({
                url: `${state.config.rep_service_url}/communications/search/fields`,
                method: `GET`,
                headers: { 'Content-Type': `application/json` },

            })
                .then(response => {
                    commit('setManagementFilterFields',response)
                }).catch(err =>
                    console.log(err)
                );
        },
        loadCommunication({state},communicationId){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/communication/${communicationId}`,
                    method: `GET`,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        loadCommunicationUpdate({state},communicationId){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/update/${communicationId}`,
                    method: `GET`,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        loadLandingPageComms({state,commit}){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/landingPage`,
                    method: `GET`,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    console.log(response);
                    if(response && !response.error){
                        commit("setLandingPageComms",response)
                    }else{
                        commit("setLandingPageComms",[])
                    }
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        loadTemplate({state},tempId){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/template/${tempId}`,
                    method: `GET`,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    console.log(response);
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        saveTemplate({state},params){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/template?userId=${params.userId}`,
                    method: `POST`,
                    body: params.requestBody,
                    needMask:true,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    console.log(response);
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        loadCommunicationUserGroup({state},params){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/notification/${params.type}/${params.commId}/grouplist`,
                    method: `GET`,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    console.log(response);
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        saveNotification({state},params){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communications/notification`,
                    method: `POST`,
                    body: params,
                    needMask:true,
                    needResultDialog:true,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    console.log(response);
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
        saveCommFilters({commit},filters){
            commit("setSavedFilters",filters)
        },
        setProcessingOverlay({state,commit},processingOverlay){
            //prevent two overlay are both shown
            if(!state.showProgressBar){
                commit("setProcessingOverlay",processingOverlay)
            }
        },
        setConfirmDialogDetails({commit},confirmObject){
            commit("setConfirmDialogDetails",confirmObject)
        },
        closeConfirmDialog({commit}){
            const confirmObject = {}
            confirmObject.showDlg = false;
            commit("setConfirmDialogDetails",confirmObject)
        },

        fetchNews({state,commit}){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/news`,
                    method: `GET`,
                    headers: { 'Content-Type': `application/json` },
                })
                .then(response => {
                    if(response && !response.error){
                        commit("setNews",response);
                    }else{
                        commit("setNews",[]);
                    }
                    
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },

        exportCommunications({state},params){
            return new Promise( (resolve, reject) => {
                state.serverProxy.serverRequest({
                    url: `${state.config.rep_service_url}/communication/download?userId=${params.userId}`,
                    method: `POST`,
                    body:params.requestdata,
                    needMask: true,
                    headers: { 'Content-Type': `application/json` },
                    responseType:'arraybuffer'
                })
                .then(response => {
                    resolve(response);
                })
                .catch(err =>             
                    reject(err)
                );
            });
        },
    },
    mutations: {
        setProgressBar(state, status) {
            state.showProgressBar = status;
        },
        setLeftBarItems(state, items) {
            state.leftBarItems = items;
        },
        setFooterItems(state, items) {
            state.footerItems = items;
        },
        setFlowItems(state, items) {
            state.flowItems = items;
        },
        setCentralItems(state, items) {
            state.centralItems = items;
        },
        setUserInfo(state, userInfo){
            state.userInfo = userInfo;
        },

        setIsCommunicationAdmin(state, isCommunicationAdmin) {
            state.isCommunicationAdmin = isCommunicationAdmin;
        },

        setIsNewsAdmin(state, isNewsAdmin) {
            state.isNewsAdmin = isNewsAdmin;
        },

        setIsSystemAdmin(state, isSystemAdmin) {
            state.isSystemAdmin = isSystemAdmin;
        },

        setIsShowcaseAdmin(state, isShowcaseAdmin) {
            state.isShowcaseAdmin = isShowcaseAdmin;
        },

        setUserSiloList(state, userSiloList){
            state.userSiloList = userSiloList;
        },

        setSiloDetails(state, siloDetails){
            state.siloDetails = siloDetails;
        },

        setSnackbarDetails(state, details) {
            state.snackbarDetails = details;
        },

        closeSnackbar(state) {
            state.snackbarDetails = {
              show: false,
              timeout: 0,
              msg: "",
            };
        },

        setCommuicationFields(state, fields){
            state.commuicationFields = fields;
        },

        setUsergroups(state, userGroups){
            state.userGroups = userGroups;
        },

        setManagementFilterFields(state, fields){
            state.managementFilterFields = fields;
        },

        setLandingPageComms(state,comms){
            state.landingPageComms = comms;
        },

        setSavedFilters(state,savedFilters){
            state.savedFilters = savedFilters;
        },

        setProcessingOverlay(state,processingOverlay){
         state.processingOverlay = processingOverlay;
        },

        setConfirmDialogDetails(state,confirmDialogDetails){
            state.confirmDialogDetails = confirmDialogDetails;
        },

        setNews(state, news){
            state.news = news;
        }
    }
}
export default REPStore;